import {
  RefreshOutlined as DefaultRetryIcon,
  WifiOffOutlined as NoNetworkIcon,
} from "@mui/icons-material";
import { Box, Button, Stack, Typography } from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";

interface ErrorStateProps {
  title: React.ReactNode;
  retryLabel?: React.ReactNode;
  retryIcon?: React.ReactNode;
  onRetry: () => void;
}

/** Shared in-content network failure state with a retry action. */
export const ErrorState: React.FC<ErrorStateProps> = ({
  title,
  retryLabel,
  retryIcon,
  onRetry,
}) => {
  const { t } = useTranslation();
  const isSimpleTitle = typeof title === "string" || typeof title === "number";

  return (
    <Stack alignItems="center" spacing={1} sx={{ py: 2, textAlign: "center" }}>
      <Box sx={{ display: "flex", color: "action.disabled" }}>
        <NoNetworkIcon sx={{ fontSize: 40 }} />
      </Box>
      {isSimpleTitle ? (
        <Typography variant="body1" sx={{ fontWeight: 600, color: "text.primary" }}>
          {title}
        </Typography>
      ) : (
        <Box sx={{ color: "text.primary", fontSize: "0.875rem" }}>{title}</Box>
      )}
      <Box sx={{ pt: 2 }}>
        <Button
          color="primary"
          onClick={onRetry}
          startIcon={retryIcon ?? <DefaultRetryIcon />}
          variant="contained"
        >
          {retryLabel ?? t("common.retry")}
        </Button>
      </Box>
    </Stack>
  );
};
